export default __webpack_public_path__ + "static/media/Doctor_02.9a60b7b4.jpg";